import {
  ApplicationConfig,
  importProvidersFrom,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withRouterConfig,
} from '@angular/router';
import {
  CustomRouteReuseStrategy,
  provideSentry,
  provideUnleash,
} from '@thiememeulenhoff/ng-sdk';
import { SecurityModule } from '@thiememeulenhoff/ng-security';
import { StoreModule } from '@thiememeulenhoff/ng-store';
import { appRoutes } from './app.routes';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    ...provideSentry,
    provideUnleash(environment.unleash),
    provideZonelessChangeDetection(),
    provideRouter(
      appRoutes,
      withEnabledBlockingInitialNavigation(),
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
      }),
    ),
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    importProvidersFrom(
      StoreModule.forRoot({
        environment: environment.environment,
      }),
      SecurityModule.forRoot({
        environment: environment.auth.environment,
        clientId: environment.auth.clientId,
        clientSecret: environment.auth.clientSecret,
      }),
    ),
  ],
};
